import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cbe3a01c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "app-footer" }, null, -1))

import { useI18n } from 'vue-i18n';
import { computed } from 'vue';
import Redirect from '@/components/redirect.vue';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { locale } = useI18n();
const isKorea = computed(() => locale.value === 'ko');

return (_ctx: any,_cache: any) => {
  const _component_b_container = _resolveComponent("b-container")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_AppTcSubscribePopup = _resolveComponent("AppTcSubscribePopup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_b_container, {
      class: "toast-container",
      toast: {root: true},
      fluid: "sm",
      position: "position-fixed"
    }),
    _createVNode(Redirect),
    _createVNode(_component_router_view),
    _hoisted_1,
    (_unref(isKorea))
      ? (_openBlock(), _createBlock(_component_AppTcSubscribePopup, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})